import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({})
export class UpdateStatus extends Mappable {
  name!: string
  value!: string
  title!: string

  static create<Data>(attrs: Data) {
    return new UpdateStatus().map(attrs)
  }
}
